import { EnergyProductionInfoModel } from '@/models';

export interface EnergyProductionState {
  energyProductionInfo: EnergyProductionInfoModel | null
}

export const InitialState: EnergyProductionState = {
  energyProductionInfo: null
}
